<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="where" label-width="77px" class="ele-form-search"
        @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="渠道名称" prop="upList">
              <el-select clearable class="ele-block" v-model.trim="where.upName" placeholder="请选择">
                <el-option v-for="item in upList" :key="item.id" :value="item.upName" :label="item.upName" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="渠道开关" prop="status">
              <el-select clearable class="ele-block" v-model.trim="where.status" placeholder="请选择">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">
                <span>查询</span>
              </el-button>
              <el-button @click="reset">
                <span>重置</span>
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
        <!-- 表头工具栏 -->
        <template slot="toolbar">
          <el-button size="small" type="success" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)"
            v-if="permission.includes('sys:uplist:add')">
            <span>添加</span>
          </el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon" :disabled="!selection.length" @click="removeBatch"
            v-if="permission.includes('sys:uplist:dall')">
            <span>删除</span>
          </el-button>
          <el-button size="small" type="warning" icon="el-icon-refresh" class="ele-btn-icon" @click="initData">
            <span>初始化</span>
          </el-button>
        </template>
        <!-- 类型列 -->
        <!-- 状态 -->
        <template slot="status" slot-scope="{row}">
          <el-switch v-model="row.status" @change="editStatus(row)" :active-value="1" :inactive-value="2"
            v-if="permission.includes('sys:uplist:status')"></el-switch>
        </template>
        <!-- 操作列 -->
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" :underline="false" @click="openEdit(row)"
            v-if="permission.includes('sys:uplist:edit')">
            <span>编辑</span>
          </el-button>
          <el-popconfirm class="ele-action" title="确定要删除此渠道吗？" @confirm="remove(row)"
            v-if="permission.includes('sys:uplist:delete')">
            <el-button size="small" type="danger" class="ele-btn-icon" :underline="false" slot="reference">
              <span>删除</span>
            </el-button>
          </el-popconfirm>
          <el-button size="small" type="success" class="ele-btn-icon" :underline="false" @click="showRoundEdit(row)"
            v-if="permission.includes('sys:uplist:edit')">
            <span>通道</span>
          </el-button>
          <el-dropdown class="ele-action" @command="(cmd) => openRowSource(row, cmd)">
            <el-button size="small" type="info" plain class="ele-btn-icon">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="in">代收接口</el-dropdown-item>
              <el-dropdown-item command="out">代付接口</el-dropdown-item>
              <el-dropdown-item command="query">订单查询</el-dropdown-item>
              <el-dropdown-item command="balance">余额查询</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </ele-pro-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <type-edit :data="current" :visible.sync="showEdit" @done="reload" />
    <!-- 轮询设置 -->
    <round-edit :data="current" :visible.sync="roundEdit" @done="reload" />
    <interface-source-dialog
      :visible.sync="showSource"
      :uplist-id="sourceRow ? sourceRow.id : 0"
      :source-type="sourceType"
      @done="reload" />
  </div>
</template>

<script>
import {
  mapGetters
} from "vuex";
import { loadDictOptions } from '@/utils/dict';
import TypeEdit from './type-edit';
import roundEdit from './round-edit';
import InterfaceSourceDialog from './interface-source-dialog.vue';

export default {
  name: 'ChannelType',
  components: {
    TypeEdit,
    roundEdit,
    InterfaceSourceDialog
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  data() {
    return {
      // 表格数据接口
      url: '/uplist/index',
      // 表格列配置
      columns: [{
        columnKey: 'selection',
        type: 'selection',
        width: 45,
        align: 'center',
        fixed: "left"
      },
      {
        prop: 'upName',
        label: '渠道名称',
        showOverflowTooltip: true,
        minWidth: 100,
        align: 'center',
      },
      {
        prop: 'upUid',
        label: '渠道编号',
        showOverflowTooltip: true,
        minWidth: 100,
        align: 'center',
      },
      {
        prop: 'upKey',
        label: '渠道密钥',
        showOverflowTooltip: true,
        minWidth: 120,
        align: 'center',
      },
      {
        prop: 'upBaseUrl',
        label: '基础地址',
        showOverflowTooltip: true,
        minWidth: 160,
        align: 'center',
      },
      {
        prop: 'status',
        label: '渠道状态',
        showOverflowTooltip: true,
        minWidth: 100,
        align: 'center',
        slot: 'status',
      },
      {
        columnKey: 'action',
        label: '操作',
        width: 300,
        align: 'center',
        resizable: false,
        slot: 'action',
        fixed: "right"
      }
      ],
      // 表格搜索条件
      where: {},
      // 表格选中数据
      selection: [],
      // 当前编辑数据
      current: null,
      // 是否显示编辑弹窗
      showEdit: false,
      roundEdit: false,
      upList: [],
      showSource: false,
      sourceRow: null,
      sourceType: 'in',
      statusOptions: []
    };
  },
  mounted() {
    loadDictOptions('switch_status', { numberValue: true })
      .then((list) => { this.statusOptions = list; })
      .catch((e) => { this.$message.error(e.message); });
    this.queryUplist();
  },
  methods: {
    /* 刷新表格 */
    reload() {
      this.$refs.table.reload({
        where: this.where
      });
    },
    /* 重置搜索 */
    reset() {
      this.where = {};
      this.reload();
    },
    /* 显示编辑 */
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    /* 获取渠道名称 */
    queryUplist() {
      this.$http.get('/Uplist/getupList').then(res => {
        if (res.data.code === 0) {
          this.upList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    /* 删除 */
    remove(row) {
      const loading = this.$loading({
        lock: true
      });
      this.$http.post('/uplist/delete', {
        id: row.id
      }).then(res => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    /* 批量删除 */
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的渠道吗？', '提示', {
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true
        });
        this.$http.post('/uplist/delete', {
          id: this.selection.map(d => d.id)
        }).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => { });
    },
    /* 初始化 */
    initData() {
      this.$confirm('初始化将清空全部上游渠道及余额且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/uplist/initData').then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.selection = [];
            this.queryUplist();
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    // 行状态改变
    editStatus(row) {
      const loading = this.$loading({
        lock: true
      });
      let params = Object.assign({
        "id": row.id,
        "status": row.status
      })
      this.$http.post('/uplist/status', params).then(res => {
        loading.close();
        if (res.data.code === 0) {
          this.$message({
            type: 'success',
            message: res.data.msg
          });
        } else {
          row.status = !row.status ? 1 : 2
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    showRoundEdit(row) {
      this.current = row;
      this.roundEdit = true;
    },
    openRowSource(row, type) {
      this.sourceRow = row;
      this.sourceType = type || 'in';
      this.showSource = true;
    }
  }
}
</script>

<style scoped></style>
